import {IApiBusinessProto, space} from "../provider_api";
import ContactMethodType = space.kenko.proto.ContactMethodType;

export const isBusinessEmailVerified = (business: IApiBusinessProto | null | undefined,
                                        email: string | null | undefined) => {
  return isBusinessContactMethodVerified(business, ContactMethodType.EMAIL, email);
}

export const isBusinessPhoneVerified = (business: IApiBusinessProto | null | undefined,
                                        email: string | null | undefined) => {
  return isBusinessContactMethodVerified(business, ContactMethodType.MOBILE_PHONE, email);
}

const isBusinessContactMethodVerified = (business: IApiBusinessProto | null | undefined,
                                         type: ContactMethodType,
                                         emailOrPhone: string | null | undefined) => {

  if (!business || !emailOrPhone || !business.verifiedContactMethods) {
    return false;
  }

  for (let i = 0; i < business.verifiedContactMethods.length; i++) {
    const existing = business.verifiedContactMethods[i];
    if (existing.contactMethod?.type == type &&
        existing.contactMethod.address == emailOrPhone) {
      return true;
    }
  }

  return false;
}